import { useState } from "react";
import { Location } from "@components/ui/location_input.tsx";
import { SearchBar } from "@components/job_search/search_bar.tsx";
import { type RecentSearch } from "@/types/job_search/recent_searches";
import { useJobSearch, buildJobsParams, recentSearchToLocation } from "@hooks/use_job_search";

type Props = {
  granularLocationSearchEnabled: boolean;
  recentSearches: RecentSearch[];
};

const SearchSection = ({ granularLocationSearchEnabled, recentSearches }: Props) => {
  const [location, setLocation] = useState<Location | null>(null);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const submitJobSearch = useJobSearch();

  const handleSearch = () => {
    setLoading(true);

    submitJobSearch(buildJobsParams(query, location), {
      onFinish: () => setLoading(false),
    });
  };

  const handleRecentSearchSelect = (search: RecentSearch) => {
    setLoading(true);

    submitJobSearch(
      buildJobsParams(search.query || undefined, recentSearchToLocation(search), search),
      { onFinish: () => setLoading(false) },
    );
  };

  return (
    <div className="welcome-search-bar-wrapper">
      <SearchBar
        query={query}
        onQueryChange={setQuery}
        location={location}
        onLocationChange={setLocation}
        onSearch={handleSearch}
        disabled={loading}
        granularLocationSearchEnabled={granularLocationSearchEnabled}
        recentSearches={recentSearches}
        onRecentSearchSelect={handleRecentSearchSelect}
      />
    </div>
  );
};

export default SearchSection;
